import { render, staticRenderFns } from "./SkeletonPolicyEditCustomCombination.vue?vue&type=template&id=3576bd26&"
import script from "./SkeletonPolicyEditCustomCombination.vue?vue&type=script&lang=js&"
export * from "./SkeletonPolicyEditCustomCombination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports